import LoaderBackdrop from '@/components/utility/LoaderBackdrop';
import Helper from '@/resources/Helper';
import DBTireSize from '@/database/TireSize';
import DBCar from '@/database/Car';
import DBCarTireSize from '@/database/CarTireSize';
import DBStock from '@/database/Stock';
import DBStockHistory from '@/database/StockHistory';

const AppUtility = {
    install (Vue) {
        Vue.component('load-backdrop', LoaderBackdrop);

        Vue.prototype.$AppUtility = {
            renderLoadBackdrop() {
                const instance = new (Vue.extend(LoaderBackdrop))({
                    el: document.createElement('div')
                });
                
                document.body.appendChild(instance.$el);

                return instance;
            },
            inputOnlyNumber(e) {
                e = (e) ? e : window.event;
                const charCode = (e.which) ? e.which : e.keyCode;
        
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    e.preventDefault();
                }
                else {
                    return true;
                }
            },
            displayOnlyDate(date) {
                let output = '';
                
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const year = date.getFullYear();
                
                output = [day, month, year].join('/');

                return output;
            },
            displayTimeFormat(date) {
                if (!date) {
                    return '';
                }

                let output = '';
                const dateOnly = new Date(date);
                const dateDate = new Date(date);
                const today = new Date();
                const yesterday = new Date();
        
                dateOnly.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                yesterday.setHours(0, 0, 0, 0);
                yesterday.setDate(yesterday.getDate() - 1);
        
                if (dateOnly.getTime() === today.getTime()) {
                    output = 'วันนี้';
                } else if (dateOnly.getTime() === yesterday.getTime()) {
                    output = 'เมื่อวาน';
                } else {
                    const month = dateDate.getMonth() + 1;
                    const day = dateDate.getDate();
                    const year = dateDate.getFullYear();
                    
                    output = [day, month, year].join('/');
                }
        
                const hour = Helper.getLeadingZero(dateDate.getHours(), 2);
                const min = Helper.getLeadingZero(dateDate.getMinutes(), 2);
        
                output = output + ' ' + ([hour, min].join(':')) + ' น.';
        
                return output;
            },
            renderByPage(page, size, index) {
                const start = (page - 1) * size;
                const end = start + size;
    
                return index >= start && index < end;
            },
            async setupTireSizeWidthOption() {
                const loader = this.renderLoadBackdrop();
                let options = [];

                const data = await DBTireSize.get();
                const list = data.content;

                list.forEach((item) => {
                    options.push({ id: item.width, name: item.width });
                });

                loader.hide();

                return options;
            },
            async setupTireSizeRatioOption(param) {
                const loader = this.renderLoadBackdrop();
                let options = [];

                const data = await DBTireSize.get();
                const selectedWidth = data.content.find(x => x.width == param.width);

                selectedWidth.listRatio.forEach((item) => {
                    options.push({ id: item.ratio, name: item.ratio });
                });

                loader.hide();

                return options;
            },
            async setupTireSizeDiameterOption(param) {
                const loader = this.renderLoadBackdrop();
                let options = [];

                const data = await DBTireSize.get();
                const selectedWidth = data.content.find(x => x.width == param.width);
                const selectedRatio = selectedWidth.listRatio.find(x => x.ratio == param.ratio);

                selectedRatio.listDiameter.forEach((item) => {
                    options.push({ id: item.diameter, name: item.diameter });
                });

                loader.hide();

                return options;
            },
            async setupCarBrandOption() {
                const loader = this.renderLoadBackdrop();
                let options = [];

                const data = await DBCar.get();
                const list = data.content;

                list.forEach((item) => {
                    options.push({ id: item.brand, name: item.brand });
                });

                loader.hide();

                return options;
            },
            async setupCarModelOption(param) {
                const loader = this.renderLoadBackdrop();
                let options = [];

                const data = await DBCar.get();
                const selectedBrand = data.content.find(x => x.brand == param.carBrand);

                selectedBrand.listModel.forEach((item) => {
                    options.push({ id: item.model, name: item.model });
                });

                loader.hide();

                return options;
            },
            async setupCarYearSerieOption(param) {
                const loader = this.renderLoadBackdrop();
                let options = [];

                const data = await DBCar.get();
                const selectedBrand = data.content.find(x => x.brand == param.carBrand);
                const selectedModel = selectedBrand.listModel.find(x => x.model == param.carModel);

                selectedModel.listYearSerie.forEach((item) => {
                    options.push({ id: item.yearSerie, name: item.yearSerie });
                });

                loader.hide();

                return options;
            },
            async inventoryFilterResult(result, filter) {
                if (filter.productCategory) {
                    result = result.filter(x => x.productData.productCategory === filter.productCategory);
                }
                if (filter.keyword) {
                    result = result.filter(x => x.productData.name.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1 
                                                || x.productData.brand.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
                }
                if (filter.priceFrom) {
                    result = result.filter(x => parseFloat(x.stockData.price) >= parseFloat(filter.priceFrom));
                }
                if (filter.priceTo) {
                    result = result.filter(x => parseFloat(x.stockData.price) <= parseFloat(filter.priceTo));
                }
                if (filter.dotFrom) {
                    result = result.filter(x => this.filterResultByDot(x.stockData.dots, filter.dotFrom, 'from'));
                }
                if (filter.dotTo) {
                    result = result.filter(x => this.filterResultByDot(x.stockData.dots, filter.dotTo, 'to'));
                }
                if (filter.carBrand || filter.carModel || filter.carYearSerie) {
                    let tireSizeFilter = await this.getCarTireSizeList(filter.carBrand, filter.carModel, filter.carYearSerie);

                    result = result.filter(x => { return this.findStartWithResult(tireSizeFilter, x.productData.size); });
                }
                if (filter.tireSizeW || filter.tireSizeR || filter.tireSizeD) {
                    let tireSizeFilter = this.getTireSizeList(filter.tireSizeW, filter.tireSizeR, filter.tireSizeD);

                    result = result.filter(x => { return this.findStartWithResult(tireSizeFilter, x.productData.size); });
                }
                if (filter.engineOilType) {
                    result = result.filter(x => x.productData.oilType === filter.engineOilType);
                }
    
                return result;
            },
            findStartWithResult(filterList, field) {
                let isFound = false;

                for (let index = 0; index < filterList.length; index++) {
                    if (field.startsWith(filterList[index])) {
                        isFound = true;
                        break;
                    }
                }

                return isFound;
            },
            filterResultByDot(dotList, name, type) {
                return dotList.some(x => {
                    let isFound = false;
                    const dotResult = this.convertDotToNumber(x.name);
                    const dotSearch = this.convertDotToNumber(name);

                    if (dotResult != 0) {
                        switch (type) {
                            case 'from':
                                if (dotResult >= dotSearch) {
                                    isFound = true;
                                }
                                break;

                            case 'to':
                                if (dotResult <= dotSearch) {
                                    isFound = true;
                                }
                                break;
                        }
                    }

                    return isFound;
                });
            },
            convertDotToNumber(dot) {
                if (dot) {
                    const week = dot.substring(0, 2);
                    const year = dot.substring(2);
    
                    return parseInt(year + week);
                }

                return 0;
            },
            async getCarTireSizeList(carBrand, carModel, carYearSerie) {
                const tireSizeList = [];
                let carTireSize = await DBCarTireSize.get();

                carTireSize = carTireSize.content.filter(x => (x.brand === carBrand || !carBrand) &&
                                                        (x.model === carModel || !carModel) &&
                                                        (x.yearSerie === carYearSerie || !carYearSerie));

                carTireSize.forEach((item) => {
                    tireSizeList.push(item.width + '/' + item.ratio + 'R' + item.diameter);
                });

                return tireSizeList;
            },
            getTireSizeList(tireSizeW, tireSizeR, tireSizeD) {
                const tireSizeList = [];
                let tireSizeText = tireSizeW + '/';

                if (tireSizeR) {
                    tireSizeText += tireSizeR + 'R';

                    if (tireSizeD) {
                        tireSizeText += tireSizeD;
                    }
                }

                tireSizeList.push(tireSizeText);

                return tireSizeList;
            },
            getAvailableStock(stockData, propertyType) {
                let available = 0;

                stockData.dots.forEach((item) => {
                    available += item[propertyType];
                });

                return available;
            },
            isAnyStockAvailable(stockData) {
                let isAvailable = false;

                for (let index = 0; index < stockData.dots.length; index++) {
                    const total = stockData.dots[index].amountNormal + stockData.dots[index].amountSublet + stockData.dots[index].amountConsign;

                    if (total > 0) {
                        isAvailable = true;
                        break;
                    }
                }

                return isAvailable;
            },
            async clearCostCounterHistory(inventoryKey, history) {
                for (let index = 0; index < history.content.length; index++) {
                    history.content[index].isCountAverage = false;
                }
    
                await DBStockHistory.update(inventoryKey, history.content);
    
                return history;
            },
            async calculateAverageCost(history) {
                let sumQty = 0;
                let sumCost = 0;

                if (history) {
                    history.content.forEach((item) => {
                        if (item.operand === DBStock.operandAction().increase && item.isCountAverage) {
                            sumQty += item.adjustAmount;
                            sumCost += item.adjustAmount * item.averageCost;
                        }
                    });
                }

                if (sumQty > 0) {
                    return parseFloat((sumCost / sumQty).toFixed(2));
                }

                return 0;
            },
            calculateOrderTotalPrice(order) {
                let totalPrice = 0;

                // Calculate Total Price
                order.productList.forEach((item) => {
                    if (item.input.price) {
                        totalPrice += parseFloat(item.input.price);
                    }
                });

                // Calculate Total Price
                order.serviceList.forEach((item) => {
                    if (item.price) {
                        totalPrice += parseFloat(item.price);
                    }
                });

                // Deduct Discount
                order.discountList.forEach((item) => {
                    if (item.discount) {
                        totalPrice -= parseFloat(item.discount);
                    }
                });

                if (totalPrice < 0) {
                    totalPrice = 0;
                }

                return totalPrice;
            },
            printTemplate(elementID) {
                var printPanel = document.getElementById(elementID).innerHTML;
                var printStyle = `
                    <style>
                        @media print { 
                            @page { 
                                size: A4;
                                margin: 0 1cm;
                            }

                            html, body {
                                margin: 0;
                                padding: 0;
                            }
                        }
                    </style>
                    <script>
                        function printPage() {
                            window.print()
                        }
                    </script>
                `;
                var printTemplate = `
                    <table>
                        <thead>
                            <tr>
                                <td>
                                    <div class="page-header-space">&nbsp;</div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    ` + printPanel + `
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <div class="page-footer-space">&nbsp;</div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                `;

                var iframe = document.frames
                    ? document.frames['printFrame']
                    : document.getElementById('printFrame');

                var iframeWindow = iframe.contentWindow || iframe;
                
                iframeWindow.document.open();
                iframeWindow.document.write(printStyle);
                iframeWindow.document.write(printTemplate);
                iframeWindow.document.close();
            
                iframe.focus();
                iframeWindow.printPage();
            },
            mapProductDataFromMaster(data) {
                return {
                    brand: data.brand,
                    brandLogo: data.brandLogo,
                    masterProductKey: data.key,
                    name: data.name,
                    priceRange: data.priceRange,
                    productCategory: data.productCategory,
                    productImage: data.productImage,
                    size: data.size
                };
            },
        };
    }
}

export default AppUtility